import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiTextField from 'material-ui/TextField';

export default class TextField extends Component {
  static propTypes = {
    onUpdate: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    onChange: PropTypes.func,
    validator: PropTypes.object,
    preserveErrorSpace: PropTypes.bool,
  };

  static defaultProps = {
    onUpdate: () => {},
    onBlur: () => {},
    onKeyDown: () => {},
    onChange: () => {},
  };

  wasChanged = false;

  invokeUpdate(ev) {
    this.wasChanged = false;
    this.props.onUpdate(ev);
  }

  handleBlur = (ev) => {
    this.props.onBlur(ev);
    if (this.wasChanged) {
      this.invokeUpdate(ev);
    }
  };

  handleKeyDown = (ev) => {
    this.props.onKeyDown(ev);
    if (ev.key === 'Enter') {
      this.invokeUpdate(ev);
    }
  };

  handleChange = (ev) => {
    this.wasChanged = true;
    this.props.onChange(ev);
    // Reset provided validator when value has changed
    const { validator } = this.props;
    if (validator && validator.isInvalid) {
      validator.reset();
    }
  };

  render() {
    const { onUpdate, onBlur, onKeyDown, validator, preserveErrorSpace, ...rest } = this.props;
    let validatorErrorProps;

    if (validator) {
      const emptyHelperText = preserveErrorSpace ? ' ' : '';
      validatorErrorProps = {
        error: validator.isInvalid,
        helperText: validator.isInvalid ? validator.getErrorMessage() : emptyHelperText
      };
    }

    return (
      <MuiTextField
        {...validatorErrorProps}
        {...rest}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        onKeyDown={this.handleKeyDown}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/atoms/TextField/index.js